module.exports = __webpack_public_path__ + "static/img/partner13.9e5f95a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/news/partner13.png
// module id = 4M+7
// module chunks = 202